var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwitterOld(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "twitter"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bg",
    d: "M0 24C0 37.2548 10.7452 48 24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24Z",
    fill: "#1DA1F2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "twitter_2",
    d: "M36 16.5C35.1 16.95 34.2 17.1 33.15 17.25C34.2 16.65 34.95 15.75 35.25 14.55C34.35 15.15 33.3 15.45 32.1 15.75C31.2 14.85 29.85 14.25 28.5 14.25C25.35 14.25 22.95 17.25 23.7 20.25C19.65 20.1 16.05 18.15 13.5 15.15C12.15 17.4 12.9 20.25 15 21.75C14.25 21.75 13.5 21.45 12.75 21.15C12.75 23.4 14.4 25.5 16.65 26.1C15.9 26.25 15.15 26.4 14.4 26.25C15 28.2 16.8 29.7 19.05 29.7C17.25 31.05 14.55 31.8 12 31.5C14.25 32.85 16.8 33.75 19.5 33.75C28.65 33.75 33.75 26.1 33.45 19.05C34.5 18.45 35.4 17.55 36 16.5Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterOld);
export default __webpack_public_path__ + "static/media/twitter_old.d523976693e22c1a718707bd5ec5915a.svg";
export { ForwardRef as ReactComponent };